import "@assets/css/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import { createHead } from "@unhead/vue/client";
import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "@/App.vue";
import { router } from "@/router";

const app = createApp(App);
const pinia = createPinia();
const head = createHead();

// Performance optimization
app.config.performance = import.meta.env.DEV; // Only enable performance tracking in development

// Compiler options for better performance
app.config.compilerOptions = {
  comments: false, // Remove comments from templates in production
  delimiters: ["${", "}"], // Use alternative delimiters to avoid conflicts with other template engines
  whitespace: "condense", // Remove unnecessary whitespace
};

// Disable development warnings in production
if (import.meta.env.PROD) {
  app.config.warnHandler = () => null;
}

// Global error handler with performance monitoring
app.config.errorHandler = (err, instance, info) => {
  if (import.meta.env.DEV) {
    console.error("[Vue] Vue Error:", {
      component: instance?.$options.name ?? "Anonymous",
      error: err,
      info,
      timestamp: new Date().toISOString(),
    });
  } else {
    // In production, add error tracking service here
    // e.g., Sentry, LogRocket, etc.
    console.error("[Vue] Vue Error:", err);
  }
};

app.use(router);
app.use(pinia);
app.use(head);
app.mount("#app");
